<template>
    <div class="roleMenuAssignDialog">
        <!-- 部分设置弹窗 -->
        <el-dialog
                class="dialog816"
                title="菜单授权"
                :visible.sync="isDialogShow"
                :before-close="hideDialog"
                :close-on-click-modal="false"
                @close="hideDialog"
        >
            <el-container style="height:100%;">
                <el-aside>
                    <div class="menuTitlePanel">菜单</div>
                    <el-tree
                            ref="menuTree"
                            :data="menuList"
                            :props="defaultProps"
                            :default-checked-keys="menuAssignedList"
                            node-key="id"
                            @node-click="MenuNodeClick"
                            show-checkbox
                            :default-expand-all="true"
                    ></el-tree>
                </el-aside>
                <el-main>
                    <div class="menuTitlePanel">菜单按钮</div>
                    <div v-show="isShowCheckAll" class="checkAll"> <el-checkbox v-model="checkedAll" @change="checkedChange($event,true)">全选</el-checkbox></div>

                    <div>
                        <el-tree
                                ref="btnTree"
                                :data="meunBtnList"
                                :props="defaultProps1"
                                show-checkbox
                                :default-checked-keys="btnAssignedList"
                                @check-change="btnCheckChanged"
                                node-key="permissionDictKey"
                        ></el-tree>
                    </div>
                </el-main>
            </el-container>
            <div slot="footer" class="dialog-footer">
                <el-button type="info" @click="hideDialog()">取 消</el-button>
                <el-button type="primary" @click="saveUserClick()">授 权</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        getRoleDeptAssginMenuTreeService,
        getMenuDetailsService,
        getRoleDeptGrantMenuBtnTreeService,
        getMenuBtnDetailService,
        getRoleAssignMenuService,
        getGrantMenuBtnService,
        changeRoleMenuService,
        getDeptAssginMenuTreeService, //获取全部菜单树 gaa 20200902
        getDeptGrantMenuBtnTreeService //获取菜单下所有按钮
    } from "../../services/sysSettingService";

    export default {
        name: "roleMenuAssignDialog",
        data() {
            return {
                menuList: [], //全部菜单列表
                meunBtnList: [], //菜单按钮列表
                menuAssignedList: [], //已授权菜单列表
                btnAssignedList: [], //已授权按钮列表

                menuCheckedKeys: [], //已选菜单
                menuHalfCheckedKeys: [], //半选菜单

                checkedBtns: [], //选中的按钮列表
                checkedBtnNodes: [], //选中的按钮对象列表

                selectMenuCode: [], //用户点击过并获取了按钮列表的menu

                checkedMenuBtns: {}, //用户点击过并勾选的菜单按钮对象

                isScreenShow: false, //高级筛选显示开关
                isDialogShow: false, //新增/修改用户显示开关
                isAddFlag: true, //新增/修改标识
                isFirstSetBtn: true,//是否是第一次渲染按钮
                defaultProps: {
                    label: "name",
                    children: "subMenuList",
                    value: "id"
                },
                defaultProps1: {
                    label: "permissionDictValue",
                    children: "subMenuList",
                    // value: "id"
                    // value: "permissionDictKey"
                },
                isShowCheckAll:false,
                checkedAll:false
            };
        },
        methods: {
            /* 父组件调用，刷新内容 */
            refreshMenu(roleCode) {
                this.roleCode = roleCode;
                this.menuList = []; //全部菜单列表
                this.meunBtnList = []; //菜单按钮列表
                this.menuAssignedList = []; //已授权菜单列表
                this.btnAssignedList = []; //已授权按钮列表

                this.menuCheckedKeys = []; //已选菜单
                this.menuHalfCheckedKeys = []; //半选菜单

                this.checkedBtns = []; //选中的按钮列表
                this.checkedBtnNodes = []; //选中的按钮对象列表

                this.selectMenuCode = []; //用户点击过并获取了按钮列表的menu
                this.isDialogShow = true;
                this.getAllMenu();
            },
            /* 获取全部菜单列表 */
            getAllMenu() {
                let params = {
                    roleCode: this.roleCode
                };
                getDeptAssginMenuTreeService(params).then(
                    res => {
                        if (res.code == 10000000) {
                            this.menuList = res.data;
                            this.getRoleAssignMenu();
                        }
                    },
                    err => {
                        this.$message.error("网络请求失败");
                    }
                );
            },
            /* 菜单点击回调事件 */
            MenuNodeClick(menu) {
                this.menuSelected = menu.id;
                if (null == menu.subMenuList || menu.subMenuList.length <= 0) {
                    this.getMenuBtnList(menu);
                }
            },
            /* 按钮多选回调 */
            btnCheckChanged(data, checked, indeterminate) {
                if (this.isFirstSetBtn) {
                    return
                }
                // 传递给 data 属性的数组中该节点所对应的对象、节点本身是否被选中、节点的子树中是否有被选中的节点
                //选中，加入
                let permissionDictKeyList = []
                if (checked) {
                    if (undefined == this.checkedMenuBtns[this.menuSelected] || null == this.checkedMenuBtns[this.menuSelected] || this.checkedMenuBtns[this.menuSelected].length <= 0) {
                        //此菜单下不存在按钮 不存在就直接menuCode.push
                        this.checkedMenuBtns[this.menuSelected] = [];
                        this.checkedMenuBtns[this.menuSelected].push(data);
                    }
                    if (this.checkedMenuBtns[this.menuSelected] && this.checkedMenuBtns[this.menuSelected].length) {
                        //菜单下存在按钮 将permissionDictKey遍历出来
                        permissionDictKeyList = this.checkedMenuBtns[this.menuSelected].map(item => {
                            return item.permissionDictKey
                        })
                    }
                    if (this.checkedMenuBtns[this.menuSelected] && permissionDictKeyList.indexOf(data.permissionDictKey) == -1) {
                        //如果菜单中存在按钮 但是没有这个按钮 直接push这个按钮
                        this.checkedMenuBtns[this.menuSelected].push(data);
                    }
                    if (this.checkedMenuBtns[this.menuSelected] && permissionDictKeyList.indexOf(data.permissionDictKey) > -1) {
                        //如果菜单中存在按钮 但是也有这个按钮 及直接splice这个按钮 以替换数据返回的错误按钮
                        this.checkedMenuBtns[this.menuSelected].splice(permissionDictKeyList.indexOf(data.permissionDictKey), 1, data)
                    }
                }
                //反选，删除
                else {
                    //如果菜单下不存在或者空数组 不用采取任何操作
                    if (!this.checkedMenuBtns[this.menuSelected] || this.checkedMenuBtns[this.menuSelected].length == 0) {
                        // this.checkedMenuBtns[this.menuSelected] = []
                        return
                    }
                    if (this.checkedMenuBtns[this.menuSelected] && this.checkedMenuBtns[this.menuSelected].length) {
                        //菜单下存在按钮 将permissionDictKey遍历出来
                        permissionDictKeyList = this.checkedMenuBtns[this.menuSelected].map(item => {
                            return item.permissionDictKey
                        })
                        //   菜单下存在按钮   如果这个按钮存在就删除  如果不存在不采取操作
                        if (permissionDictKeyList.indexOf(data.permissionDictKey) > -1) {
                            this.checkedMenuBtns[this.menuSelected].splice(permissionDictKeyList.indexOf(data.permissionDictKey), 1)
                        }
                    }
                }
                console.log('length',this.checkedMenuBtns[this.menuSelected].length,this.meunBtnList.length)
                if(this.checkedMenuBtns[this.menuSelected].length<this.meunBtnList.length){
                    this.checkedAll=false
                }

            },
            //全选按钮回调
            checkedChange(value,type){
                console.log('checkedChange',value,type)
                let _this = this
                //如果是点击全选 则将所有数据存起来 并将所有数据勾选
                // console.log(this.checkedMenuBtns,this.menuSelected,this.meunBtnList)
                if(value){
                    this.checkedMenuBtns[this.menuSelected]=[]
                    this.checkedMenuBtns[this.menuSelected] = JSON.parse(JSON.stringify(this.meunBtnList))
                    this.$refs.btnTree.setCheckedNodes(this.checkedMenuBtns[this.menuSelected]);
                }else{
                    this.checkedMenuBtns[this.menuSelected] = []
                    this.$refs.btnTree.setCheckedNodes([]);
                }

            },
            /* 保存按钮回调 */
            saveUserClick() {
                if (this.menuList.length <= 0) {
                    this.$alert("当前用户无菜单管理权限", "提示");
                    return;
                }
                // let menus = this.menuHalfCheckedKeys.concat(this.menuCheckedKeys);
                let menus = this.$refs.menuTree
                    .getHalfCheckedKeys()
                    .concat(this.$refs.menuTree.getCheckedKeys());
                //获取已勾选的菜单id
                // console.log(this.checkedBtnNodes);
                let menuparams = [];
                for (let i = 0; i < menus.length; i++) {
                    let id = menus[i];
                    // param.id = id;
                    let param = {
                        id: id,
                        rolesPermissionsList: []
                    };
                    if (
                        null != this.checkedMenuBtns[id] &&
                        this.checkedMenuBtns[id].length > 0
                    ) {
                        //  循环里面的id
                        for (let j = 0; j < this.checkedMenuBtns[id].length; j++) {
                            let rolesPermissionsList = {};
                            rolesPermissionsList.menuId = id;
                            rolesPermissionsList.permissionId = this.checkedMenuBtns[id][j].id;

                            param.rolesPermissionsList.push(rolesPermissionsList);
                        }
                    }

                    menuparams.push(param);
                }
                // this.changeRoleMenu(menus, this.checkedBtnNodes, this.selectMenuCode);
                this.changeRoleMenu(menuparams);
            },
            /* 关闭弹窗，清空数据 */
            hideDialog() {
                this.isShowCheckAll=false
                this.checkedAll=false
                this.menuAssignedList = [];
                this.btnAssignedList = [];
                this.menuList = [];
                this.meunBtnList = [];
                //清空树
                this.menuAssignedList.forEach(menu => {
                    this.$refs.menuTree.setChecked(menu.id, false);
                });
                this.btnAssignedList.forEach(btn => {
                    this.$refs.btnTree.setChecked(btn.id, false);
                });
                this.isDialogShow = false;
            },
            /* 获取菜单包含按钮列表 */
            getMenuBtnList(menu) {
                this.checkedAll=false
                this.isShowCheckAll=true
                let _this = this
                let menuCode = menu.id;
                let requestParam = {
                    menuId: menuCode
                };
                getDeptGrantMenuBtnTreeService(requestParam).then(
                    res => {
                        if (res.code == 10000000) {
                            _this.meunBtnList = res.data;
                            this.btnAssignedList = [];
                            let assignedList = _this.checkedMenuBtns[menuCode];
                            if(_this.checkedMenuBtns[menuCode]&&_this.checkedMenuBtns[menuCode].length&&res.data.length&&res.data.length==_this.checkedMenuBtns[menuCode].length){
                                _this.checkedAll=true
                            }
                            this.isFirstSetBtn = false
                            if (undefined != assignedList) {
                                // this.$nextTick(() => {
                                this.isFirstSetBtn = true
                                this.$refs.btnTree.setCheckedNodes([]);
                                setTimeout(() => {
                                    this.isFirstSetBtn = false
                                    this.$refs.btnTree.setCheckedNodes(assignedList);
                                }, 20)

                                // })
                            }
                        }
                    },
                    err => {
                        this.$message.error("网络请求失败");
                    }
                );
            },
            /* 获取菜单包含按钮已授权列表 */
            getGrantMenuBtn(menu) {
                if (null != menu.permissionList && menu.permissionList.length > 0) {
                    let assignedList = menu.permissionList;
                    this.btnAssignedList = [];
                    assignedList.forEach(btn => {
                        this.btnAssignedList.push(btn.id);
                    });
                    // console.log("btnAssignedList=" + this.btnAssignedList);
                    this.checkedMenuBtns[menu.id] = this.btnAssignedList;
                    this.$refs.btnTree.setCheckedKeys(this.btnAssignedList);
                } else {
                    this.checkedMenuBtns[menu.id] = [];
                }
            },
            /* 获取角色已授权菜单列表 */
            getRoleAssignMenu() {
                let requestParam = {
                    roleId: this.roleCode
                };
                getRoleAssignMenuService(requestParam).then(
                    res => {
                        if (res.code == 10000000) {
                            this.checkedMenuBtns = {}
                            this.setSelectedBtn(res.data)
                            for (let i = 0; i < res.data.length; i++) {
                                let item = res.data[i];
                                this.findMenuForDefault(item.id, this.menuList);
                                // if (menu.subMenuList.length > 0) {
                                //   let subitem = menu.subMenuList
                                //   for (let i = 0; i < subitem.length; i++) {
                                //     let subitem = menu.subMenuList[i];
                                //     this.findMenuForDefault(subitem.id, this.menuList);
                                //   }
                                // }
                            }

                            this.$refs.menuTree.setCheckedKeys(this.menuAssignedList);
                        }
                    },
                    err => {
                        this.$message.error("网络请求失败");
                    }
                );
            },
            findMenuForDefault(menuCode, menuList) {
                for (let i = 0; i < menuList.length; i++) {
                    let menu = menuList[i];
                    //如果直接找到菜单，判断是否叶子节点，如果是叶子节点插入选中列表
                    if (menu.id == menuCode && menu.subMenuList.length <= 0) {
                        this.menuAssignedList.push(menu.id);
                        if (null != menu.permissionList && menu.permissionList.length > 0) {
                            //这里循环产生已经存在的数据并修改
                            for (i in this.checkedMenuBtns) {
                                if (i == menu.id) {
                                    let aa = this.checkedMenuBtns[i]
                                    let bb = menu.permissionList
                                    for (let j = 0; j < aa.length; j++) {
                                        for (let k = 0; k < bb.length; k++) {
                                            if (aa[j].permissionDictKey == bb[k].permissionDictKey) {
                                                this.checkedMenuBtns[i][j].id = bb[k].id
                                            }
                                        }
                                    }
                                }
                            }
                            let assignedList = menu.permissionList;
                            this.btnAssignedList = [];
                            assignedList.forEach(btn => {
                                this.btnAssignedList.push(btn);
                            });
                            // console.log("btnAssignedList=" + this.btnAssignedList);
                        }
                        return;
                    }
                    //如果没找到菜单，判断是否有子菜单，如果有则循环子菜单
                    if (menu.subMenuList.length > 0) {
                        let isFind = this.findMenuForDefault(menuCode, menu.subMenuList);
                        // if(isFind) return true;
                    }
                }
                // return false;
            },
            /*设置菜单中的按钮*/
            setSelectedBtn(data) {
                for (let i = 0; i < data.length; i++) {
                    if (data[i].subMenuList && data[i].subMenuList.length) {
                        this.setSelectedBtn(data[i].subMenuList)
                    } else if (data[i].permissionList && data[i].permissionList.length) {
                        this.checkedMenuBtns[data[i].id] = data[i].permissionList
                    }
                }
                // console.log('已经勾选的信息>>', this.checkedMenuBtns)
            },
            /* 菜单授权保存 */
            changeRoleMenu(menuparams) {
                let requestParam = {
                    // roleId: this.roleCode,
                    menuList: menuparams
                };
                changeRoleMenuService(menuparams, this.roleCode).then(
                    res => {
                        // console.log(res);
                        if (res.code == 10000000) {
                            this.$alert("菜单授权成功", "提示");
                            this.isDialogShow = false;
                        } else if (res.code >= 20000000) {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定"
                            });
                        } else {
                            this.$alert("系统异常", "提示", {
                                confirmButtonText: "确定"
                            });
                        }
                    },
                    err => {
                        this.$message.error("网络请求失败");
                    }
                );
            }
        }
    };
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";

    .roleMenuAssignDialog {
        // height: 100%;
        background-color: white;
    }

    .screenPanel {
        text-align: left;
        min-height: 40px;
        padding: 16px 0 0 0;
    }

    .handlePanel {
        text-align: right;
        // padding: 0 20px;
    }

    .menuTitlePanel {
        font-size: 14px;
        font-weight: 500;
        text-align: left;
        margin-bottom: 1px;
        padding: 10px 32px;
        background-color: #fff;
    }
    .checkAll{
        background: #ffffff;
        height: 30px;
        line-height: 30px;
        padding-left: 10px;
    }

    .operatePanel {
        text-align: right;
        margin: 16px 0;
    }

    .el-select {
        width: 100%;
    }

    .el-form-item__label {
        text-align: left;
    }

    .el-main {
        padding: 0 8px !important;
    }

    .el-aside .el-tree {
        background-color: #fff;
        min-height: 90%;
    }

    /deep/ .el-dialog__body {
        height: 500px;
        background-color: #f2f3f7;
    }

    .el-footer {
        text-align: right;
    }

    // /deep/.el-dialog {
    //   width: 80%;
    // }
</style>
